import React from 'react'
import PropTypes from 'prop-types'
import OpalCard from '../../../../../opal/OpalCard'
import InlineCardHeader from '../../../../../molecules/Card/InlineCardHeader'
import SydButton from '../../../../../commonDesign/Button'

function VersionHistoryTab ({ blueprint, versions, onSetActive, onDeleteVersion }) {
  return (
    <OpalCard size='sm'>
      <InlineCardHeader>Version History</InlineCardHeader>
      <div style={{ padding: '16px' }}>
        {versions && versions.length > 0 ? (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #ddd', backgroundColor: '#f5f5f5' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Version ID</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Description</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Created</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {versions.map((version) => {
                const isActive = version.definitionVersionId === blueprint.definitionVersionId
                return (
                  <tr key={version.definitionId} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{version.definitionVersionId}</td>
                    <td style={{ padding: '12px' }}>{version.description || '-'}</td>
                    <td style={{ padding: '12px' }}>
                      {version.versionDate ? new Date(version.versionDate).toLocaleDateString() : '-'}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {isActive ? (
                        <span style={{ color: '#4caf50', fontWeight: 'bold' }}>Active</span>
                      ) : (
                        <span style={{ color: '#999' }}>Inactive</span>
                      )}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {!isActive ? (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <SydButton
                            size='sm'
                            variant='ghost'
                            onClick={() => onSetActive(version)}
                          >
                            Set Active
                          </SydButton>
                          <SydButton
                            size='sm'
                            variant='ghost'
                            icon='delete'
                            onClick={() => onDeleteVersion(version)}
                          >
                            Delete
                          </SydButton>
                        </div>
                      ) : (
                        <span style={{ color: '#999', fontSize: '0.875rem' }}>Current</span>
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <p>No versions available</p>
        )}
      </div>
    </OpalCard>
  )
}

VersionHistoryTab.propTypes = {
  blueprint: PropTypes.object.isRequired,
  versions: PropTypes.array,
  onSetActive: PropTypes.func.isRequired,
  onDeleteVersion: PropTypes.func.isRequired
}

VersionHistoryTab.defaultProps = {
  versions: []
}

export default VersionHistoryTab
